import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';

export const getDefaultHsSitesDomain = () => {
  const portalId = PortalIdParser.get();
  const domainBase = `${portalId}.${enviro.isQa() ? 'hs-sitesqa' : 'hs-sites'}`;
  return enviro.ifHublet({
    isNa1: () => {
      return `${domainBase}.com`;
    },
    isNonNa1: () => {
      return `${domainBase}-${enviro.getHublet()}.com`;
    },
  });
};

export const buildPrivateVideoPosterUrl = (shareKey: string) => {
  return `${getFullUrl(
    'api'
  )}/video/v1/public/share/${shareKey}/poster?portalId=${PortalIdParser.get()}`;
};
